// Add interfaces for type safety
interface BankInfo {
  bank_name?: string;
  bank_branch?: string;
  bank_account_number?: string;
  bank_iban?: string;
  bank_swift?: string;
  bank_account_type?: string;
}

interface ReferencesData {
  bank: BankInfo;
  suppliers: any[];
}

interface Contact {
  name?: string;
  position?: string;
  phone?: string | number;
  email?: string;
}

interface Supplier {
  name?: string;
  contact_person?: string;
  phone?: string | number;
}

interface Signature {
  name?: string;
  position?: string;
}

interface Requests {
  credit_limit?: number;
  credit_period?: string | number;
}

export const validateGeneralStep = (data: {
  general: {
    outlet_legal_name: string;
    outlet_trade_name: string;
    billing_outlet_address: string;
    billing_country: string;
    billing_city: string;
    billing_phone: string;
    billing_po_box: string;
    billing_nearest_landmark: string;
    delivery_outlet_address: string;
    delivery_country: string;
    delivery_city: string;
    delivery_phone: string;
    delivery_po_box: string;
    // service_years: string;
    // website_url: string;
  };
  license?: {
    license_number: string;
    license_expiration: Date;
  };
}) => {
  const generalData = data.general;
  const licenseData = data.license;

  return (
    generalData &&
    generalData.outlet_legal_name &&
    generalData.outlet_trade_name &&
    generalData.billing_outlet_address &&
    generalData.billing_country &&
    generalData.billing_city &&
    generalData.billing_phone &&
    generalData.billing_po_box &&
    generalData.delivery_outlet_address &&
    generalData.delivery_country &&
    generalData.delivery_city &&
    generalData.delivery_phone &&
    generalData.delivery_po_box &&
    // generalData.service_years &&
    // generalData.website_url &&
    licenseData?.license_number &&
    licenseData?.license_expiration
  );
};

export const validateContactsStep = (data: { contacts: Contact[] }): boolean => {
  if (!data.contacts || !Array.isArray(data.contacts)) return false;
  
  return data.contacts.length > 0 && data.contacts.every(contact => 
    contact.name?.toString().trim() !== '' &&
    contact.position?.toString().trim() !== '' &&
    contact.phone?.toString().trim() !== '' &&
    contact.email?.toString().trim() !== ''
  );
};

export const validateReferencesStep = (data: ReferencesData): boolean => {
  if (!data.bank || !data.suppliers) return false;

  const requiredBankFields = [
    'bank_name',
    'bank_branch',
    'bank_account_number',
    'bank_iban',
    'bank_swift',
    'bank_account_type'
  ];

  const hasAllBankFields = requiredBankFields.every(
    field => data.bank[field as keyof BankInfo]?.toString().trim() !== ''
  );

  const hasValidSuppliers = Array.isArray(data.suppliers) && 
    data.suppliers.length > 0 &&
    data.suppliers.every((supplier: Supplier) => 
      supplier.name?.toString().trim() !== '' &&
      supplier.contact_person?.toString().trim() !== '' &&
      supplier.phone?.toString().trim() !== ''
    );

  return hasAllBankFields && hasValidSuppliers;
};

export const validateUploadsStep = (data: {
  signatures?: Signature[];
  requests?: Requests;
}): boolean => {
  if (!data.signatures || !data.requests) return false;

  const hasValidSignatures = Array.isArray(data.signatures) && 
    data.signatures.length > 0 &&
    data.signatures.every(sig => 
      sig.name?.toString().trim() !== '' && 
      sig.position?.toString().trim() !== ''
    );

  const hasValidRequests = 
    data.requests.credit_limit !== undefined &&
    data.requests.credit_limit > 0 &&
    data.requests.credit_period !== undefined &&
    data.requests.credit_period.toString().trim() !== '';

  return hasValidSignatures && hasValidRequests;
};
